import { getLocaleUrlPath } from './i18n';
import { getHrefAllExchangers } from './urls';

export const dumpCurrencyRates = (currencyRates, locale, city) => {
  if (!currencyRates) {
    return null;
  }

  const formattedRates = [];

  Object.keys(currencyRates).forEach(currency => {
    const truthRate = currencyRates[currency]?.[0];

    let sort = null;
    if (currency === 'eur') {
      sort = 2;
    } else if (currency === 'pln') {
      sort = 3;
    } else sort = 1;

    const rate = {
      date: truthRate.date,
      currency: truthRate?.currency || currency,
      ask: truthRate?.sell.toFixed(2) || '-',
      bid: truthRate?.buy.toFixed(2) || '-',
      trendBid: truthRate?.buyDx || null,
      trendAsk: truthRate?.sellDx || null,
      sort,
      button: city
        ? getHrefAllExchangers({ locale, currency, city })
        : `https://minfin.com.ua${getLocaleUrlPath(
            locale
          )}/currency/auction/${currency}/buy/all/`,
    };
    formattedRates.push(rate);
  });

  return formattedRates.sort((a, b) => a.sort - b.sort);
};

export const dumpVaRatesGraphByCurrency = currencyRates => {
  if (!currencyRates) {
    return null;
  }

  return currencyRates.map(truthRate => {
    return {
      date: truthRate.date,
      currency: truthRate?.currency,
      ask: truthRate?.sell.toFixed(2) || '-',
      bid: truthRate?.buy.toFixed(2) || '-',
    };
  });
};

export default dumpCurrencyRates();
